export default "__VITE_ASSET__0d4a5299__"